"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationTab = exports.InstallationTab = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _PanelItems = require("../PanelItems");

var _AccordionPanel = _interopRequireDefault(require("@insided/deprecated-control/panel/AccordionPanel"));

var _InstallationPanel = require("./InstallationPanel");

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _Message = require("@insided/deprecated-control/ui-components/Message");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _FederatedSearchSyncStatus = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/searchSyncStatus/FederatedSearchSyncStatus"));

var _constants = require("@insided/shared/constants");

var IntegrationTab = function IntegrationTab(_ref) {
  var activePanel = _ref.activePanel,
      isInstalled = _ref.isInstalled,
      isFederatedSearchActive = _ref.isFederatedSearchActive,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      onSettingChanged = _ref.onSettingChanged,
      showActionButtons = _ref.showActionButtons,
      hasUnsavedChanges = _ref.hasUnsavedChanges,
      showUnsavedChangesModal = _ref.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref.displayUnsavedChangedModal,
      _closeModal = _ref.closeModal,
      _resetChanges = _ref.resetChanges,
      storedState = _ref.storedState,
      onClickPanelCallback = _ref.onClickPanelCallback,
      isSavingFederatedSearchSetting = _ref.isSavingFederatedSearchSetting,
      federatedSearchInitialSyncCompleted = _ref.federatedSearchInitialSyncCompleted;
  var FederatedSearchIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Skilljar federated search',
    toggleLabel: 'Enable Skilljar federated search',
    isInstalled: isInstalled,
    isSettingEnabled: isFederatedSearchActive,
    storedIsSettingEnabled: storedState.isFederatedSearchActive,
    imageFromName: 'skilljar-s',
    imageToName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    description: "Empower end users to search for Skilljar courses through ".concat(_constants.PLATFORM_BRAND_NAME, "."),
    onSave: onSave,
    onCancel: onCancel,
    onSettingChanged: onSettingChanged,
    showActionButtons: showActionButtons,
    hasUnsavedChanges: hasUnsavedChanges,
    onClickPanel: onClickPanelCallback,
    customClass: 'qa-skilljar-federated-search',
    communityArticleLink: 'https://community.insided.com/integrations-124/how-to-set-up-a-federated-search-integration-with-skilljar-3257',
    additionalHelpText: (0, _preact.h)(AdditionalHelpText, null),
    isLoading: isSavingFederatedSearchSetting,
    integrationStatus: (0, _preact.h)(_FederatedSearchSyncStatus.default, {
      isFederatedSearchActive: storedState.isFederatedSearchActive,
      federatedSearchInitialSyncCompleted: federatedSearchInitialSyncCompleted,
      syncUrl: "/integration/skilljar/sync",
      syncedDataType: "Skilljar courses"
    })
  });
  return (0, _preact.h)("div", {
    className: "integration__tab"
  }, !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "Please install the app first to configure the integrations.",
    fullWidth: true
  }), (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: activePanel,
    panels: [FederatedSearchIntegrationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  }), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal();
    },
    resetChanges: function resetChanges() {
      return _resetChanges();
    }
  }));
};

exports.IntegrationTab = IntegrationTab;

var AdditionalHelpText = function AdditionalHelpText() {
  var communityUrl = (0, _globals.default)('communityUrl');
  return (0, _preact.h)("span", null, "View Skilljar courses in the", ' ', (0, _preact.h)("a", {
    className: "overview-page-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(communityUrl.concat('/search')),
    rel: "noreferrer",
    target: "_blank"
  }, "search result"), ' ', "on the community destination.", ' ');
};

var InstallationTab = function InstallationTab(_ref2) {
  var isInstalled = _ref2.isInstalled,
      onSave = _ref2.onSave,
      onCancel = _ref2.onCancel,
      apiKey = _ref2.apiKey,
      onClickManage = _ref2.onClickManage,
      onApiKeyChangeCallback = _ref2.onApiKeyChangeCallback,
      onApiKeyClickCallback = _ref2.onApiKeyClickCallback,
      onSubdomainChangeCallback = _ref2.onSubdomainChangeCallback,
      onSubdomainClickCallback = _ref2.onSubdomainClickCallback,
      onClickUninstall = _ref2.onClickUninstall,
      subdomain = _ref2.subdomain,
      errorFields = _ref2.errorFields,
      hasUnsavedChanges = _ref2.hasUnsavedChanges,
      showUnsavedChangesModal = _ref2.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref2.displayUnsavedChangedModal,
      _closeModal2 = _ref2.closeModal,
      _resetChanges2 = _ref2.resetChanges,
      isSavingCredentials = _ref2.isSavingCredentials;
  var SkilljarInstallationPanel = (0, _InstallationPanel.getInstallationPanel)({
    isInstalled: isInstalled,
    onSave: onSave,
    onCancel: onCancel,
    onApiKeyChangeCallback: onApiKeyChangeCallback,
    onApiKeyClickCallback: onApiKeyClickCallback,
    onSubdomainChangeCallback: onSubdomainChangeCallback,
    onSubdomainClickCallback: onSubdomainClickCallback,
    onClickManage: onClickManage,
    onClickUninstall: onClickUninstall,
    apiKey: apiKey,
    subdomain: subdomain,
    errorFields: errorFields,
    hasUnsavedChanges: hasUnsavedChanges,
    isSavingCredentials: isSavingCredentials
  });
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (0, _preact.h)("div", {
    className: "installation__tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [SkilljarInstallationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  })), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal2();
    },
    resetChanges: function resetChanges() {
      return _resetChanges2();
    }
  }));
};

exports.InstallationTab = InstallationTab;